import "core-js/modules/es6.array.is-array";

var isKeyframesTarget = function isKeyframesTarget(v) {
  return Array.isArray(v);
};

export { isKeyframesTarget };